import React from "react";
import PropTypes from "prop-types";
import { ChapterMenu } from "../ChapterMenu";
import "./style.scss";

export function DesignSectionMenu(props) {
  const className = `d-menu ${props.className}`;

  return (
    <ChapterMenu.Wrapper
      className={className}
      onClick={props.onSelect}
      onEnterKey={props.onSelect}
      tabIndex={props.tabIndex}
    >
      <ChapterMenu.IndexNumber className="d-menu_index" number={props.number} menuList={props.menuList} />
      <ChapterMenu.Label className="d-menu_label" title={props.title} />
      <ChapterMenu.GoBackIcon className="d-menu_back" />
      <ChapterMenu.InfoIcon
        tabIndex={0}
        className="d-menu_tour"
        onClick={props.onClickInfo}
      />
    </ChapterMenu.Wrapper>
  );
}

DesignSectionMenu.propTypes = {
  /**
   * Callback fired when a Menu is Selected
   */
  onSelect: PropTypes.func,
  /**
   * Title to display in  menu
   */
  title: PropTypes.string.isRequired,
  /**
   * Index number of menu
   */
  number: PropTypes.number.isRequired,
  /**
   * TabIndex to set on Menu
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * List of Menu Items for calculating adjusted numbers
   */
  menuList: PropTypes.arrayOf(PropTypes.object)
};

DesignSectionMenu.defaultProps = {
  className: "",
  title: "",
  number: 0,
  tabIndex: 0,
};
